import { axiosModules } from "@qubit-utill/src";

export default {
  getProgramNameList: () => {
    return axiosModules.get("/pfilter/programmessage/programnames");
  },
};
